import "./modules/common";
import VueGoodshareFacebook from "vue-goodshare/src/providers/Facebook.vue";
import VueGoodshareLinkedIn from "vue-goodshare/src/providers/LinkedIn.vue";
import VueGoodshareEmail from "vue-goodshare/src/providers/Email.vue";
import VueGoodshareXTwitter from "~/Components/SocialShare/XTwitter.vue";
import VueApp from "~/Scripts/new/vueApp";
import AccordionItem from "~/Components/AccordionItem.vue";
import SimplePricing from "~/Components/Product/SimplePricing.vue";
import ProductImagesWrapper from "~/Components/Product/ProductImagesWrapper.vue";
import WishlistModal from "~/Components/Wishlist/WishlistModal.vue";

new VueApp( {
  name: "WorkshopItem",
  components: {
    AccordionItem,
    SimplePricing,
    ProductImagesWrapper,
    VueGoodshareFacebook,
    VueGoodshareXTwitter,
    VueGoodshareLinkedIn,
    VueGoodshareEmail,
    WishlistModal,
  },
  data: () => ( {
    showWishlistModal: false,
  } ),
} );
